import { LoadState } from "@redotech/react-util/load";
import { MinimalConversation } from "@redotech/redo-model/conversation";
import { Flex } from "@redotech/redo-web/flex";
import { CartData } from "@redotech/shopify-storefront";
import classNames from "classnames";
import { memo } from "react";
import { ConversationDetailsCustomer } from "./conversation-details-customer";
import { ConversationDetailsOrders } from "./conversation-details-orders";
import { ConversationDetailsOverview } from "./conversation-details-overview";
import * as conversationDetailsPanelCss from "./conversation-details-panel.module.css";
import { ConversationInsightDetails } from "./conversation-insight-details";
import { ConversationDetailsSubscriptions } from "./subscriptions/conversation-details-subscriptions";

export const ConversationDetailsPanel = memo(function ConversationDetailsPanel({
  conversation,
  setConversationAssignee,
  setActiveConversation,
  ordersLoad,
  doOrdersLoad,
  returnsLoad,
  doReturnsLoad,
  cartsLoad,
  doCartsLoad,
  onInsightsUpdated,
}: {
  conversation: MinimalConversation;
  setConversationAssignee: (assignee: any) => void;
  setActiveConversation: (conversation: MinimalConversation) => void;
  ordersLoad: LoadState<any>;
  doOrdersLoad: () => void;
  returnsLoad: LoadState<any>;
  doReturnsLoad: () => void;
  cartsLoad: LoadState<CartData[] | undefined>;
  doCartsLoad: () => void;
  onInsightsUpdated?: (
    conversationInsights: MinimalConversation["conversationInsights"],
  ) => void;
}) {
  return (
    <Flex
      className={classNames(conversationDetailsPanelCss.panelWrapper)}
      dir="column"
      w="full"
    >
      <ConversationDetailsOverview
        conversation={conversation}
        setConversationAssignee={setConversationAssignee}
      />
      {conversation.conversationInsights?.insights && (
        <ConversationInsightDetails
          conversationId={conversation._id}
          insights={conversation.conversationInsights.insights}
          onInsightsUpdated={onInsightsUpdated}
          teamId={conversation.team}
        />
      )}
      <ConversationDetailsCustomer
        conversation={conversation}
        doCartsLoad={doCartsLoad}
        doOrdersLoad={doOrdersLoad}
        doReturnsLoad={doReturnsLoad}
        orders={ordersLoad.value}
        returns={returnsLoad.value}
        setActiveConversation={setActiveConversation}
      />
      <ConversationDetailsSubscriptions conversation={conversation} />
      <ConversationDetailsOrders
        cartsLoad={cartsLoad}
        doOrdersLoad={doOrdersLoad}
        doReturnsLoad={doReturnsLoad}
        ordersLoad={ordersLoad}
        returnsLoad={returnsLoad}
      />
    </Flex>
  );
});
